import * as React from "react";
import { Dispatch, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { ExplorerHistoricalPricesPDF } from '../components/';

import { IState, IWatchlist, IResultEntity, IDataEntity, IDataEntityResponse, IFundFilterResponse, IShareClassFilterResponse, IFilterRequest, ISearch, IAppParams, ITypeahead, ISorting, IInifiniteScroll } from "../models";
import { getFunds, getFilters, changeFilter, toggleFund, toggleShareClass, toggleAllFunds, toggleShareClassPerformance, changeSortOrder, editWatchlist, execInfiniteScroll, getDisclaimers } from "../actions";

import { BASE_SEARCH_REQUEST } from "../data";

interface IProps {
	route?: { appParams: IAppParams }
	disclaimers?: {};
	isLoading?: boolean;
	appParams?: IAppParams;
	getFunds?: typeof getFunds;
	funds?: IDataEntityResponse;
	filterOptions?: IFundFilterResponse & IShareClassFilterResponse;
	filter?: IFilterRequest;
	typeahead?: ITypeahead[];
	changeFilter?: typeof changeFilter;
	getFilters?: typeof getFilters;
	collapsedFunds?: string[];
	toggleFund?: typeof toggleFund;
	toggleShareClass?: typeof toggleShareClass;
	toggleShareClassPerformance?: typeof toggleShareClassPerformance;
	toggleAllFunds?: typeof toggleAllFunds;
	changeSortOrder?: typeof changeSortOrder;
	sorting?: ISorting;
	editWatchlist?: typeof editWatchlist;
	watchlist?: IWatchlist[];
	infiniteScroll?: IInifiniteScroll;
	execInfiniteScroll?: typeof execInfiniteScroll;
	getDisclaimers?: typeof getDisclaimers;
}

@connect(mapStateToProps, mapDispatchToProps)
export class HistoricalSharePricesPrint extends React.Component<React.Props<{}> & IProps, {}>{
	componentWillMount() {
		let { appParams } = this.props;
		let optionsString = appParams._location.query["options"];
		let options = {
			search: [{
				property: "isin",
				values: [appParams.isin],
				matchtype: "MATCH"
			}]
		};
		if (optionsString) {
			try {
				options = JSON.parse(optionsString);
			}
			catch (ex) {
				console.log('Cannot parse "options" querystring parameter: ' + ex.message);
			}
		}
		this.props.changeFilter(options, appParams);
		this.props.getDisclaimers(appParams);

		//this.props.getFunds(Object.assign({}, BASE_SEARCH_REQUEST, options), appParams, true);
	}

	render() {
		let { appParams } = this.props;
		let { funds, filterOptions, watchlist, changeFilter, filter, toggleFund, toggleShareClass, toggleShareClassPerformance, toggleAllFunds, isLoading, typeahead, sorting, changeSortOrder, editWatchlist, infiniteScroll, execInfiniteScroll, disclaimers } = this.props;
		if (Object.keys(disclaimers).length === 0) {
			return null;
		}

		return (
			<div className="ktsys-fund-explorer">
				<ExplorerHistoricalPricesPDF
					isLoading={isLoading}
					funds={funds}
					editWatchlist={editWatchlist}
					watchlist={watchlist}
					appParams={appParams}
					toggleFund={toggleFund}
					toggleShareClassPerformance={toggleShareClassPerformance}
					toggleShareClass={toggleShareClass}
					toggleAllFunds={toggleAllFunds}
					sorting={sorting}
					changeSortOrder={changeSortOrder}
					execInfiniteScroll={execInfiniteScroll}
					infiniteScroll={infiniteScroll}
					disclaimers={disclaimers} />
			</div>
		);
	}
}

function mapStateToProps(state: IState, ownProps: any): IProps {
	return {
		isLoading: state.loading.isLoading,
		funds: state.funds,
		filterOptions: state.filterOptions,
		typeahead: state.typeahead as ITypeahead[],
		filter: state.filter,
		collapsedFunds: state.collapsedFunds,
		sorting: state.sorting,
		watchlist: state.watchlist,
		infiniteScroll: state.infiniteScroll,
		disclaimers: state.disclaimers
	};
}

function mapDispatchToProps(dispatch: Dispatch<IState>): IProps {
	return {
		getFunds: bindActionCreators(getFunds, dispatch),
		getFilters: bindActionCreators(getFilters, dispatch),
		changeFilter: bindActionCreators(changeFilter, dispatch),
		toggleShareClassPerformance: bindActionCreators(toggleShareClassPerformance, dispatch),
		toggleShareClass: bindActionCreators(toggleShareClass, dispatch),
		toggleFund: bindActionCreators(toggleFund, dispatch),
		toggleAllFunds: bindActionCreators(toggleAllFunds, dispatch),
		changeSortOrder: bindActionCreators(changeSortOrder, dispatch),
		editWatchlist: bindActionCreators(editWatchlist, dispatch),
		execInfiniteScroll: bindActionCreators(execInfiniteScroll, dispatch),
		getDisclaimers: bindActionCreators(getDisclaimers, dispatch)
	};
}



// WEBPACK FOOTER //
// ./src/client/containers/HistoricalSharePricesPrint.tsx